import SchedulePanel from './EditChannelPanel';

export default SchedulePanel;
